if (!customElements.get('faq-glossary')) {
  class FaqGlossary extends HTMLElement {
    constructor() {
      super();
      this.searchInput = this.querySelector('[data-glossary-search]');
      this.clearBtn = this.querySelector('[data-glossary-clear]');
      this.content = this.querySelector('[data-glossary-content]');
      this.noResults = this.querySelector('[data-glossary-no-results]');
      this.items = this.querySelectorAll('[data-glossary-item]');
      this.groups = this.querySelectorAll('[data-glossary-group]');
      this.navLinks = this.querySelectorAll('[data-glossary-nav-link]');
      this.observer = null;
    }

    connectedCallback() {
      this.searchInput?.addEventListener('input', this.handleSearch.bind(this));
      this.clearBtn?.addEventListener('click', this.handleClear.bind(this));
      this.navLinks.forEach(link => {
        link.addEventListener('click', this.handleNavClick.bind(this));
      });
      this.setupScrollObserver();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setupScrollObserver() {
      if (!this.groups.length) return;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '80', 10);
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const category = entry.target.dataset.glossaryGroup;
              this.setActiveNav(category);
            }
          });
        },
        {
          rootMargin: `-${headerHeight + 100}px 0px -60% 0px`,
          threshold: 0
        }
      );
      this.groups.forEach(group => this.observer.observe(group));
    }

    setActiveNav(category) {
      this.navLinks.forEach(link => {
        link.classList.toggle('is-active', link.dataset.glossaryNavLink === category);
      });
    }

    handleNavClick(e) {
      e.preventDefault();
      const href = e.currentTarget.getAttribute('href');
      const target = this.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    handleSearch() {
      const query = this.searchInput.value.trim().toLowerCase();
      this.clearBtn.style.display = query ? '' : 'none';

      if (!query) {
        this.items.forEach(item => item.classList.remove('is-hidden'));
        this.groups.forEach(group => group.classList.remove('is-hidden'));
        this.noResults.style.display = 'none';
        return;
      }

      let visibleCount = 0;
      const visibleGroups = new Set();

      this.items.forEach(item => {
        const title = item.querySelector('.faq-glossary__item-title');
        const text = title?.textContent?.toLowerCase() || '';
        const match = text.includes(query);
        item.classList.toggle('is-hidden', !match);
        if (match) {
          visibleCount++;
          const prevGroup = this.findPreviousGroup(item);
          if (prevGroup) visibleGroups.add(prevGroup);
        }
      });

      this.groups.forEach(group => {
        group.classList.toggle('is-hidden', !visibleGroups.has(group));
      });

      this.noResults.style.display = visibleCount === 0 ? '' : 'none';
    }

    findPreviousGroup(item) {
      let el = item.previousElementSibling;
      while (el) {
        if (el.dataset.glossaryGroup !== undefined) return el;
        el = el.previousElementSibling;
      }
      return null;
    }

    handleClear() {
      this.searchInput.value = '';
      this.handleSearch();
      this.searchInput.focus();
    }
  }

  customElements.define('faq-glossary', FaqGlossary);
}
